'use client'
import { AnimatePresence } from 'framer-motion'
import { Toaster as HotToaster, resolveValue } from 'react-hot-toast'
import ToastBar from './toast-bar'

const Toaster = () => {
  return (
    <HotToaster position="bottom-right" containerStyle={{ zIndex: 99999999999 }}>
      {(t) => (
        <AnimatePresence>
          {t.visible && <ToastBar position={t.position || 'bottom-right'} type={t.type} message={resolveValue(t.message, t)} icon={t.icon} duration={t.duration! / 1000} />}
        </AnimatePresence>
      )}
    </HotToaster>
  )
}

export default Toaster
